import dynamic from 'next/dynamic';
const ValdHubSlider = dynamic(() => import('./ValdHubSlider'));
export default ValdHubSlider;
